import React, { PropTypes } from 'react';
import Select from 'react-select';
import axios from './../../constants/axios';
import  './CompinedStyle.less';

class SelectAsync extends React.Component {
   constructor(props) {
      super(props);
   }

   itemLoaders = (name) => {
      const { link } = this.props;
      return axios(`${link}/${name}`)
         .then(function (res) {
            let n = res.data.map(function (i) {
               return {
                  label: i.name,
                  value: i.id
               };
            });
            return { options: n };
         });
   };


   render() {
      const { input, initial, label, minimumInput, meta: { touched, error } } = this.props;
      return (
         <div className="form-group" >
            {label && <label>{label}</label>}
            <Select.Async {...input} loadOptions={this.itemLoaders}
                          initial={initial}
                          minimumInput={minimumInput}
                          onBlur={() => input.onBlur(input.value.value)} />
            {touched && error && <span
               className="input-validation-error"
            >{error}</span>}
         </div>
      );
   }
}


SelectAsync.propTypes = {
   input: PropTypes.object,
   link: PropTypes.string.isRequired,
   meta: PropTypes.object,
   label: PropTypes.string,
   minimumInput: PropTypes.number,
   initial: PropTypes.array
};
export default SelectAsync;



/** WEBPACK FOOTER **
 ** ./src/components/FormTemplate/SelectAsync.js
 **/